import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod/v4-mini"
import {TextureType} from "@generated"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            angleInDegrees: z._default(z.number().check(z.gte(-180), z.lte(180)), 0),
            textureType: z.enum(TextureType),
        }),
    },
}
